import { usePageMeta } from "../hooks/usePageMeta";
import { useEffect } from "react";

export default function NotFound() {
  usePageMeta({
    title: "Page introuvable — Amyu",
    description: "Cette page n'existe pas sur amyu.fr.",
  });

  // Tell search engines to drop this URL
  useEffect(() => {
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, nofollow");
    return () => robots.setAttribute("content", "index, follow");
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-amyu-bg px-5 text-center">
      <h1 className="font-display text-6xl text-coral">404</h1>
      <p className="mt-4 text-lg text-amyu-muted max-w-md">
        Cette page n&apos;existe pas ou plus. Retour à la maison ?
      </p>
      <a
        href="/"
        className="mt-8 inline-block bg-coral text-white rounded-full px-6 py-3 font-medium"
      >
        Revenir à l&apos;accueil
      </a>
    </div>
  );
}
